import React from 'react';
import { Icon } from '@amzn/awsui-components-core';
import { useNavigate } from 'react-router-dom';
import { NotificationActions } from '../../interfaces/interface';
import { NotificationBell } from '../notifications/NotificationBell';
import { ImpersonationButton } from '../../../../impersonation/ImpersonationButton';
import styles from './Sidebar.module.scss';

export interface SidebarHeaderProps {
  isRefreshing: boolean;
  onRefresh?: () => void;
  notificationActions: NotificationActions;
  isHuddlePlusAdmin?: boolean;
}

export const SidebarHeader: React.FC<SidebarHeaderProps> = ({ isRefreshing, onRefresh, notificationActions, isHuddlePlusAdmin }) => {
  const navigate = useNavigate();

  return (
    <div className={styles.header}>
      <div className={styles.controls}>
        <NotificationBell
          unreadCount={notificationActions.unreadCount}
          notifications={notificationActions.allNotifications}
          isLoading={notificationActions.isLoading}
          onOpen={notificationActions.loadNotifications}
          onMarkAsRead={notificationActions.markAsRead}
          onDismiss={notificationActions.dismissNotification}
          onMarkAllAsRead={notificationActions.markAllAsRead}
        />
        {onRefresh && (
          <button type="button" className={styles.iconButton} onClick={onRefresh} disabled={isRefreshing} aria-label="Refresh">
            <span className={isRefreshing ? styles.spinning : undefined}>
              <Icon name="refresh" size="small" />
            </span>
          </button>
        )}
        <ImpersonationButton />
        {isHuddlePlusAdmin && (
          <button
            type="button"
            className={styles.iconButton}
            onClick={() => navigate('/admin/ea-huddle')}
            aria-label="Open Huddle+ Admin Configuration"
            title="Open Huddle+ Admin Configuration"
          >
            <Icon name="settings" size="small" />
          </button>
        )}
      </div>
    </div>
  );
};
